// extracted by mini-css-extract-plugin
export default {"mainTitle":"MainTitle_mainTitle__2g-VS","title":"MainTitle_title__5+bW2"};